<template>
  <div>
    <v-container>
      <div class="d-flex justify-space-between align-baseline mb-4">
        <!-- <div>
          <avs-switch
            mdi1="mdi-view-sequential"
            mdi2="mdi-view-module"
            :spantext="$t('messages.information.change_display')"
            @switch="v => changeDisplay(v)"
          />
        </div> -->
        <!-- <v-spacer></v-spacer> -->
        <v-row class="mb-5">
          <v-col
            cols="12"
            md="9"
            style="margin-top: -15px"
          >
            <v-text-field
              clearable
              hide-details
              prepend-inner-icon="mdi-magnify"
              :label="$t('commons.search')"
              v-model="search"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <avs-createButton
              :spantext="$t('actions.create', { entity: $t('commons.department').toLowerCase() })"
              menu
              :name="$t('actions.new', { entity: $t('commons.department').toLowerCase() })"
              @click="handleOpenEditDialogByComponent()"
            />
          </v-col>
        </v-row>
      </div>

      <v-row>
        <v-col
          v-bind="layout"
          v-for="(item, i) in filteredItems"
          :key="i"
        >
          <v-card
            class="pb-0 mb-0 rounded-xl d-flex flex-wrap flex-column justify-space-between"
            height="100%"
            @click="handleOpenEditDialog(item)"
          >
            <v-card-title>
              <span
                class="text-h5 font-weight-bold"
                style="color: #33597f !important"
                >{{ item.name }}</span
              >
            </v-card-title>
            <v-card-subtitle>
              <span v-html="truncateText(item.description, 30)"></span>
            </v-card-subtitle>
            <v-card-actions>
              <avs-editButton
                @click.stop="handleOpenEditDialog(item)"
                :spantext="$t('actions.edit', { entity: $t('commons.fieldtype').toLowerCase() })"
              />
              <avs-deleteButton
                @click.stop="handleOpenDeleteDialog(item)"
                :spantext="$t('actions.delete', { entity: $t('commons.fieldtype').toLowerCase() })"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog
        v-model="editDialogIsOpen"
        width="40vw"
      >
        <component
          v-model="selectedItem"
          :hasUniqueName="hasUniqueName"
          :is="editDialogContent"
          :isEditable="isEditable"
          @cancel="handleCancel"
          @error="handleError"
          @success="handleSuccess"
        />
      </v-dialog>

      <DeleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Department"
      />
    </v-container>
  </div>
</template>

<script>
import { toDatetime } from "@/utils/datetime"
import { DepartmentService } from "@/services"
import { mkUnique } from "@/utils/validator"
import DeleteDialog from "@/components/generics/dialogs/DeleteDialog.vue"
import DepartmentEditor from "@/components/ri3/department/DepartmentEditor.vue"

export default {
  name: "Department",
  components: { DeleteDialog, DepartmentEditor },
  created() {
    this.fetchFieldTypes()
  },
  computed: {
    hasUniqueName() {
      const names = this.items.filter(e => e.name !== this.selectedItem?.name).map(e => e.name)
      return mkUnique(names, "name")
    },
    company() {
      return this.$store.state.app.company
    },
    filteredItems() {
      return this.items.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  data() {
    return {
      isEditable: true,
      items: [],
      search: "",
      deleteDialogIsOpen: false,
      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined,
      layout: { cols: "12", md: "4", sm: "6", xs: "12" }
    }
  },
  methods: {
    toDatetime,
    fetchFieldTypes() {
      DepartmentService.getDepartment(this.company.pk).then(response => {
        this.items = response
      })
    },
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) + "..." : text
    },
    handleOpenDeleteDialog(item) {
      this.selectedItem = item
      this.deleteDialogIsOpen = true
    },
    handleOpenEditDialog(item) {
      this.selectedItem = item
      this.handleOpenEditDialogByComponent()
    },
    handleOpenEditDialogByComponent() {
      this.editDialogIsOpen = true
      this.editDialogContent = "DepartmentEditor"
    },
    handleCancel() {
      this.selectedItem = undefined
      this.deleteDialogIsOpen = false
      this.editDialogIsOpen = false
      this.editDialogContent = null
    },
    handleError(message) {
      this.send(message || this.$t("messages.error.failed_admin", { role: "INSPECTOR" }), "error")
    },
    handleSuccess() {
      this.handleCancel()
      this.$nextTick(() => {
        this.fetchFieldTypes()
        this.send(this.$t("messages.success.operation"), "success")
      })
    },
    handleDelete() {
      DepartmentService.delete(this.selectedItem.id)
        .then(() => {
          this.handleSuccess()
        })
        .catch(error => {
          const message = error?.response.data?.state
          this.handleError(message)
        })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    changeDisplay(value) {
      this.layout = value
        ? { cols: "12", md: "4", sm: "6", xs: "12" }
        : { cols: "12", md: "12", sm: "12", xs: "12" }
    }
  }
}
</script>
